export default "<ngx-feedback-main-btn *ngIf=\"showFeedbackBtn\"></ngx-feedback-main-btn>\n<router-outlet></router-outlet>\n"